import { _single } from "../../../../core/services/dataBean/EntityCatalog";
import { RemoteTable } from "../RemoteTable";
import { SelectBudgetID } from "../../../admin/configuracion/BudgetID/SelectBudgetID";
import { XlsxFormatTable } from "../XlsxFormatTable";
import { SelectBusinessCore } from "../../../erp/cellEditor/BusinessCore/SelectBusinessCore";
import { SelectIndirectConstTypeEditor } from "../../../Factoty&Production/IndirectCostType/SelectIndirectConstTypeEditor";
import { SelectStoreEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/SelectStore.editor";
import { RemoteFixedAssetItem } from "../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/RemoteFixedAssetItem";
import { RemoteWorkMaintenanceOrder } from "../../../RemoteAbstractAction/components/com/quickdataerp/bean/fixedassets/WorkMaintenanceOrder/RemoteWorkMaintenanceOrder";
import { FinancialMovementTax } from "../../../RemoteAbstractAction/components/com/quickdataerp/bean/tax/FinancialMovementTax/FinancialMovementTax";
import { SelectContractEditor } from "../../../Talentohumano/GestionTH/EmployeeContract/Editor/SelectContractEditor";
import { SelectorBrandDestinityAccountantID } from "../../../RemoteAbstractAction/components/fixedassets/BrandDestinityAccountantID/SelectorBrandDestinityAccountantID";
import { InventoryRemissionFactory } from "../../../RemoteAbstractAction/components/account/documents/inventoryremission/InventoryRemissionFactory/InventoryRemissionFactory";
import { UBLInvoiceFactory } from "../../../RemoteAbstractAction/components/account/documents/ublsalesaccountantdocument/UBLInvoiceFactory/UBLInvoiceFactory";
import { FixedAssetLineEditor } from "../../../editor/fixedAssets/FixedAssetLine.editor";
import { SelectFixedAsset } from "../../../contract/etapa-contrato/contrac/ublinvoice/FixedAssetItem/FixedAsset/SelectFixedAsset";
import { AdminProcess } from "../../../erp/cellEditor/PaymentHeader/AdminProcess";
import { FortnightDocumentStep } from "../../../RemoteAbstractAction/components/account/documents/fortnight/gui/FortnightDocumentStep";
import { SingPanelEditor } from "../../../contabilidad/SignAndApprovalPanel/SingPanelEditor";
import { CustomProcessTypeEditor } from "../../../erp/cellEditor/CustomProcessType/CustomProcessTypeEditor";
import { SelectFunctionalID } from "../../../admin/configuracion/functionalID/SelectFunctionalID";
import { EmployeeList } from "../../../RemoteAbstractAction/components/com/quickdataerp/bean/admin/Employees/EmployeeList";
import { CostingCenterSelect } from "../../../erp/cellEditor/CostingCenter/CostingCenterSelect";
import { SelectorDocumentFactory } from "../../../contabilidad/bodegaDocumentos/SelectorDocumentFactory";
import { SelectAccountantTree } from "../../../contabilidad/catalogo-cuentas/AccountantTree/SelectAccountantTree";
import { SelectTaxSchemeContext } from "../../../admin/ConfImpuestos/TaxSchemeCode/SelectTaxSchemeContext";
import { RemoteTaxScheme } from "../../../RemoteAbstractAction/components/com/quickdataerp/bean/admin/TaxScheme/RemoteTaxScheme";
import { CreateUBLInvoiceEditor } from "../../../contract/etapa-contrato/contrac/ublinvoice/CreateUBLInvoice/CreateUBLInvoiceEditor";
import { ObligationBudget } from "../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/ObligationBudget/ObligationBudget";
import { WelfareEntityEditorTable } from "../../../Talentohumano/WelfareEntity/WelfareEntityEditorTable";
import { FortnightLiquidationEditor } from "../../../Talentohumano/GestionTH/Fortnight/FortnightLiquidationEditor";
import { AccountantConceptEditor } from "../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/AccountantConcept/AccountantConceptEditor";
import { ProductionOrderEditor } from "../../../Factoty&Production/ProductionOrder/ProductionOrderEditor";
import { CostProductionOrderEditor } from "../../../Factoty&Production/ProductionOrder/getCostProductionOrderCatalog/CostProductionOrderEditor";
import { UBLDocumentCatalogEditor } from "../../../contabilidad/CatalogoDocumentosUBL/UBLDocumentCatalogEditor";
import { SelectProductEditor } from "../../../Factoty&Production/ManufacturingStandars/Components/SelectProductEditor";
import { EditorTaxSchemeValue } from "../../../RemoteAbstractAction/components/com/quickdataerp/bean/admin/TaxSchemeValue/EditorTaxSchemeValue";
import { SelectAdquisitionContract } from "../../../RemoteAbstractAction/components/com/quickdataerp/actions/steps/SelectAdquisitionContract";
import { SelectProject } from "../../../erp/cellEditor/BudgetAccountantOperation/SelectProject";
import { ProjectSelectEditor } from "../../../RemoteAbstractAction/editors/ProjectSelectEditor";
import { IncomeDocumentResponsible } from "../../../Treasury/IncomeDocumentResponsible/IncomeDocumentResponsible";
import { AccountEditor } from "../../../editor/AccountEditor";
import { BasicSwitch } from "../../../theme/Component/BasicSwitch";
import { InputDate } from "../../../theme/Input/InputDate";
import { FileInput } from "../../../theme/Component/FileInput";
import { InputMoney } from "../../../theme/Input/InputMoney";
import { GenericSelect } from "../../../RemoteAbstractAction/editors/GenericSelect";
import { SelectUnspscID } from "../../../admin/configuracion/UnspscID/SelectUnspscID";
import { PrintJson } from "../../../theme/Component/PrintJson";
import { ExpedienteTRD } from "../../../expediente/ExpedienteTRD";

interface UseObjectRendererProps {
    bean: any;
    setBean: (bean: any) => void;
    idApplicationInvoker: any;
    data: any;
    handleChange?: (e: any) => void;
    updateAndFireEvent?: (e: any, property: string) => void;
    remote?: any;
}

export const SUPPORTED_TYPES = [
    'java.util.List',
    'com.quickdataerp.bean.budget.BudgetID',
    'com.quickdataerp.bean.admin.XlsxFormat',
    'com.quickdataerp.bean.accountant.BusinessCore',
    'com.quickdataerp.bean.productionorders.IndirectCostType',
    'inventory.Store',
    'fixedassets.FixedAssetItem',
    'com.quickdataerp.bean.fixedassets.WorkMaintenanceOrder',
    'com.quickdataerp.bean.tax.FinancialMovementTax',
    'employees.EmployeeContract',
    'fixedassets.BrandDestinityAccountantID',
    'account.documents.inventoryremission.InventoryRemissionFactory',
    'account.documents.ublsalesaccountantdocument.UBLInvoiceFactory',
    'fixedassets.FixedAssetLine',
    'fixedassets.FixedAsset',
    'admin.Process',
    'account.documents.fortnight.FortnightFactory',
    'com.quickdataerp.bean.documents.SignAndApprovalPanel',
    'com.quickdataerp.bean.admin.CustomProcessType',
    'com.orange.bean.functional.FunctionalID',
    'com.quickdataerp.bean.employees.EmployeeList',
    'com.quickdataerp.bean.accountant.CostingCenter',
    'documents.DocumentFactory',
    'com.quickdataerp.bean.accountant.AccountantID',
    'com.quickdataerp.bean.admin.TaxSchemeContext',
    'com.quickdataerp.bean.admin.TaxScheme',
    'com.quickdataerp.bean.ubl.UBLInvoice',
    'com.quickdataerp.bean.budget.ObligationBudget',
    'admin.WelfareEntity',
    'employees.EmployeeIncapacity',
    'account.AccountantConcept',
    'com.quickdataerp.bean.productionorders.ProductionOrder',
    'com.quickdataerp.bean.productionorders.CostProductionOrder',
    'com.quickdataerp.bean.ubl.UBLDocument',
    'inventory.Product',
    'com.quickdataerp.bean.admin.TaxSchemeValue',
    'com.orange.bean.AdquisitionContract',
    'com.orange.bean.Project',
    'com.quickdataerp.bean.accountant.Project',
    'com.quickdataerp.bean.documents.IncomeDocument',
    'com.advantage.bean.account.AbstractAccount',
    'java.lang.Boolean',
    'java.util.Date',
    'java.io.File',
    'java.lang.Double',
    'java.lang.String',
    'java.sql.Clob',
    'java.lang.Number',
    'java.lang.Object',
    'com.orange.bean.unspsc.UnspscID'
];


export const useObjectRenderer = ({
    bean,
    setBean,
    idApplicationInvoker,
    data,
    handleChange,
    updateAndFireEvent,
    remote
}: UseObjectRendererProps) => {

    const defaultHandleChange = (e: any) => {
        const newBean = { ...bean };
        newBean[e.target.name] = _single.getValueInput(e);
        setBean(newBean);
    };

    const defaultUpdateAndFireEvent = (e: any, property: string) => {
        const newBean = { ...bean, [property]: e[property] };
        setBean(newBean);
    };

    const actualHandleChange = handleChange || defaultHandleChange;
    const actualUpdateAndFireEvent = updateAndFireEvent || defaultUpdateAndFireEvent;

    const renderInput = (editor: any) => {

        let caso = editor.EditorObjectClassForName ? editor.EditorObjectClassForName : editor.ReturnClassForName;

        if (editor.Editable === false) {
            return (
                <>
                    <label>{editor.Name} </label>
                    <input type="String" readOnly className="form-control readOnly" name={editor.IDProperty} value={bean[editor.IDProperty]} />
                </>
            )
        }

        switch (caso) {
            case 'java.util.List':
                return (
                    <>
                        <RemoteTable classForName={remote.ClassForName} dataParent={bean} nameTable={editor.Name ?? ''} propertyName={editor.IDProperty}
                            idApplicationInvoker={idApplicationInvoker} fieldList={editor.TableStructureObject} data={bean[editor.IDProperty]}
                            setData={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />

                    </>

                )
            case 'com.quickdataerp.bean.budget.BudgetID':
                return (
                    <SelectBudgetID jsonCode={editor.RenderizedObject} edit={false}
                        label={editor.Name}
                        onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName ?? 'JsonCode'] }) }}
                    />
                )
            case 'com.quickdataerp.bean.admin.XlsxFormat':
                return (
                    <XlsxFormatTable name={editor.Name} list={editor.DefaultValue} />
                )
            case 'com.quickdataerp.bean.accountant.BusinessCore':
                return (
                    <SelectBusinessCore returnType="Object" idSelector={bean[editor.IDProperty]} label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'com.quickdataerp.bean.productionorders.IndirectCostType':
                return (
                    <SelectIndirectConstTypeEditor label="Tipos de Costos Indirectos" render={bean.Name} idSelector={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e.IDIndirectCostType, "Name": e.Name }) }} returnType="Object" />
                )

            case 'inventory.Store':
                return (
                    <SelectStoreEditor idSelector={bean[editor.DefaultValue]} onChange={(e) => { console.log(e); setBean({ ...bean, [editor.IDProperty]: e.IDStore }) }} />
                )
            case 'fixedassets.FixedAssetItem':
                return (
                    <RemoteFixedAssetItem StateActive={editor?.EditorProperties?.FixedAssetItemState ?? []} label={editor.Name} onChange={(e: any) => { console.log(e[editor.EditorObjectPropertyName]); setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'com.quickdataerp.bean.fixedassets.WorkMaintenanceOrder':
                return (
                    <RemoteWorkMaintenanceOrder label={editor.Name} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'com.quickdataerp.bean.tax.FinancialMovementTax':
                return (
                    <FinancialMovementTax label={editor.Name} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'employees.EmployeeContract':
                return (
                    <SelectContractEditor onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} value={bean[editor.DefaultValue]} label={editor.Name} />
                )
            case 'fixedassets.BrandDestinityAccountantID':
                return (
                    <SelectorBrandDestinityAccountantID idLine={bean.IDLineDestinity} idSelector={bean[editor.DefaultValue]} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} label={editor.Name} />
                )
            case 'account.documents.inventoryremission.InventoryRemissionFactory':
                return (
                    <InventoryRemissionFactory onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} label={editor.Name} />
                )
            case 'account.documents.ublsalesaccountantdocument.UBLInvoiceFactory':
                return (
                    <UBLInvoiceFactory onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} label={editor.Name} />
                )
            case 'fixedassets.FixedAssetLine':
                return (
                    <FixedAssetLineEditor label={editor.Name} idSelector={bean[editor.DefaultValue]} onChange={(e) => { console.log(e); setBean({ ...bean, [editor.IDProperty]: e.IDLine }) }} />
                )
            case 'fixedassets.FixedAsset':
                return (
                    <SelectFixedAsset idSelector={bean[editor.DefaultValue]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'admin.Process':
                return (
                    <AdminProcess returnType="Object" processType={data.ProcessType} idSelector={bean[editor.IDProperty]} label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'account.documents.fortnight.FortnightFactory':
                return (
                    <FortnightDocumentStep cancreate lastStep idApplicationInvoker={idApplicationInvoker} properties={{ ProductList: bean[editor.IDProperty] }} data={bean} setData={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'com.quickdataerp.bean.documents.SignAndApprovalPanel':
                return (
                    <SingPanelEditor idSelector={bean[editor.DefaultValue]} onChange={(e) => { console.log(e); setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )

            case 'com.quickdataerp.bean.admin.CustomProcessType':
                return (
                    <CustomProcessTypeEditor idSelector={bean[editor.IDProperty]} label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'com.orange.bean.functional.FunctionalID':
                return (
                    <SelectFunctionalID label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'com.quickdataerp.bean.employees.EmployeeList':
                return (
                    // <SelectFunctionalID label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                    <EmployeeList onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} label={editor.Name} />
                )
            case 'com.quickdataerp.bean.accountant.CostingCenter':
                return (
                    <CostingCenterSelect
                        returnType="Object"
                        label={editor.Name}
                        onChange={(e) => {
                            const value = e?.[editor.EditorObjectPropertyName];
                            setBean({ ...bean, [editor.IDProperty]: value ?? null, });
                        }} />
                )
            case 'documents.DocumentFactory':
                return (
                    <SelectorDocumentFactory label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'com.quickdataerp.bean.accountant.AccountantID':
                return (
                    <SelectAccountantTree value={editor.RenderizedObject} label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'com.quickdataerp.bean.admin.TaxSchemeContext':
                return (
                    <SelectTaxSchemeContext label={editor.Name} idSelector={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'com.quickdataerp.bean.admin.TaxScheme':
                return (
                    <RemoteTaxScheme label={editor.Name} idTaxSchemContext={bean.IDTaxSchemeContext} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'com.quickdataerp.bean.ubl.UBLInvoice':
                return (
                    <CreateUBLInvoiceEditor data={bean} label={editor.Name} renderValue={editor.DefaultValue} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'com.quickdataerp.bean.budget.ObligationBudget':
                return (
                    <>
                        <ObligationBudget label="Obligaciones Presupuestales" IDAccount={bean.IDAccount} render={bean.BudgetResourceName} idSelector={bean[editor.IDProperty]} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e, "BudgetResourceName": e.BudgetResourceName }) }} returnType="Object" />
                    </>


                )
            case 'admin.WelfareEntity':
                return (
                    <WelfareEntityEditorTable label="Fondo Pagador" render={bean.WelfareEntityName} idSelector={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e.IDWelfareEntity, "WelfareEntityName": e.Coderender }) }} returnType="Object" />
                )
            case 'employees.EmployeeIncapacity':
                return (
                    <>
                        <FortnightLiquidationEditor label="Incapacidad" render={bean.EmployeeNamefor} idSelector={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e, "EmployeeNamefor": `${e.EmployeeName} - $${e.Value}` }) }} />
                    </>


                )
            case 'account.AccountantConcept':
                return (
                    <>
                        {/* <PrintJson json={bean.DocumentFactoryClass} /> */}
                        <AccountantConceptEditor label="Cuenta Contable" DocumentFactoryClass={bean.DocumentFactoryClass} render={bean.AccountantIDName} idSelector={bean[editor.IDProperty]} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e.IDAccountantConcept, "AccountantIDName": e.AccountantIDName }) }} returnType="Object" />
                    </>


                )
            case 'com.quickdataerp.bean.productionorders.ProductionOrder':
                return (
                    //  <ProductionOrderEditor IDOrderProduction={order} returnData={(e) => { setOrder({ ...order, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }); console.log(e) }} />
                    <ProductionOrderEditor IDOrderProduction={bean[editor.IDProperty]} returnData={(e) => { setBean({ ...bean, "IDProductionOrder": e.IDProductionOrder, "ProductionOrderDate": e.ProductionOrderDate }) }} />
                )
            case 'com.quickdataerp.bean.productionorders.CostProductionOrder':
                return (
                    <>
                        <CostProductionOrderEditor label="Costos de Producción WIP" idProductionOrder={bean.IDProductionOrder} productionOrderDate={bean.ProductionOrderDate} render={bean.AccountantIDName} idSelector={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e, "AccountantIDName": e.AccountantIDName }) }} returnType="Object" />
                    </>

                )
            case 'com.quickdataerp.bean.ubl.UBLDocument':
                return (
                    <UBLDocumentCatalogEditor typeUBL={bean.UBLDocumentType} label={editor.Name} renderValue={editor.DefaultValue}
                        onChange={(e) => {
                            setBean({
                                ...bean,
                                [editor.IDProperty]: { DataBeanProperties: e, DataBeanName: 'com.quickdataerp.bean.ubl.UBLInvoice' }
                                , "MovementValue": e.TotalInvoiceAmount
                                , "IDAccount": e.IDAccountCustomer
                            }
                            )
                        }} />
                    // onChange={(e)=>{actualUpdateAndFireEvent({DataBeanProperties:e,DataBeanName:'com.quickdataerp.bean.ubl.UBLInvoice'},editor.IDProperty)}} />                    
                )
            case 'inventory.Product':
                return (
                    <SelectProductEditor renderValue={bean.Description} label={editor.Name} value={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e.IDProduct }) }} />
                )
            case 'com.quickdataerp.bean.admin.TaxSchemeValue':
                return (
                    <EditorTaxSchemeValue _Value={bean[editor.IDProperty]} _onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e.IDTaxSchemeValue }) }} configProps={{ label: editor.Name }} />
                )
            case 'com.orange.bean.AdquisitionContract':
                return (

                    <SelectAdquisitionContract data={bean} idSelector={bean[editor.IDProperty]} onChange={(e: any) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'com.orange.bean.Project':
                return (
                    <SelectProject label={editor.Name} idSelector={bean[editor.IDProject] ? bean[editor.IDProject] : bean.IDProject} onChange={(e) => {
                        const value = e?.[editor.EditorObjectPropertyName] ? e?.[editor.EditorObjectPropertyName] : e?.IDProject ?? null;
                        setBean({ ...bean, [editor.IDProperty]: value })
                    }} returnType="Object" />
                )
            case 'com.quickdataerp.bean.accountant.Project':
                return (
                    <ProjectSelectEditor render={bean.ProjectName} idSelector={bean.IDProject} onChange={(e) => { setBean({ ...bean, "IDProject": e.IDProject, "ProjectName": e.Name }) }} label=" " returnType="Object" />

                )
            case 'com.quickdataerp.bean.documents.IncomeDocument':
                return (
                    <IncomeDocumentResponsible label={editor.Name} renderValue={bean[editor.RenderizedObject]} onChange={(e: any) => { actualUpdateAndFireEvent(e, editor.IDProperty) }} />
                )
            case 'com.orange.bean.unspsc.UnspscID':
                return (
                    <SelectUnspscID label={editor.Name} idln={bean[editor.IDProperty]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e.IDLn }) }} />
                )
            case 'com.advantage.bean.account.AbstractAccount':
                return (
                    <AccountEditor idAccount={bean[editor.IDProperty]} label={editor.Name} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e[editor.EditorObjectPropertyName] }) }} />
                )
            case 'java.lang.Boolean':
                return (
                    <BasicSwitch label={editor.Name} estado={bean[editor.IDProperty]} eventChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'java.util.Date':
                return (
                    <InputDate label={editor.Name} name={editor.IDProperty} value={bean[editor.IDProperty ?? editor.DefaultValue]} setDate={(e) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                )
            case 'java.io.File':
                return (
                    <FileInput directory="temp" label={editor.Name} onCreate={({ Media }: any) => { setBean({ ...bean, [editor.IDProperty]: Media }) }} />
                )
            case 'com.advantage.bean.filemanagement.FileMap':
                return (
                    <ExpedienteTRD isDocumentFactory dataExpediente={bean} typeExpediente="DOCUMENTO" />
                )
            case 'java.lang.Double':
                return (
                    <>
                        <label>{editor.Name} </label>
                        <InputMoney _value={bean[editor.IDProperty ?? editor.DefaultValue]} onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e }) }} />
                        {/* <input type="number" className="form-control" name={editor.IDProperty} value={bean[editor.IDProperty ?? editor.DefaultValue]} onChange={handleChange} /> */}
                    </>
                )
            case 'java.lang.String':
                return (
                    <>
                        {editor.Options ?
                            <>
                                <label>{editor.Name} </label>
                                <GenericSelect idSelect={bean[editor.IDProperty]} name={editor.IDProperty}
                                    onChange={(e) => { setBean({ ...bean, [editor.IDProperty]: e.target.value }) }}
                                    lista={editor.Options} />
                            </>
                            :
                            <>
                                <label>{editor.Name} </label>
                                <input type="String" className="form-control" name={editor.IDProperty} value={bean[editor.IDProperty ?? editor.DefaultValue]} onChange={actualHandleChange} />
                            </>
                        }
                    </>
                )
            case 'java.sql.Clob':
                return (
                    <>
                        <label>{editor.Name} </label>
                        <textarea className="form-control" rows={3} name={editor.IDProperty} value={bean[editor.IDProperty]} onChange={actualHandleChange}></textarea>

                    </>
                )
            case 'java.lang.Number':
                return (
                    <>
                        {editor.Options ?
                            <>
                                <label>{editor.Name} </label>
                                <GenericSelect idSelect={bean[editor.IDProperty]} name={editor.IDProperty}
                                    onChange={actualHandleChange}

                                    lista={editor.Options} />
                            </>
                            :
                            <>
                                <label>{editor.Name} </label>
                                <input type="number" className="form-control" name={editor.IDProperty} value={bean[editor.IDProperty ?? editor.DefaultValue]} onChange={actualHandleChange} />
                            </>
                        }
                    </>
                )
            case 'java.lang.Object':
                return (
                    <>
                        {editor.Options ?
                            <>
                                <label>{editor.Name} </label>
                                <GenericSelect name={editor.IDProperty} returnType="Object"
                                    onChange={(e) => {
                                        setBean({ ...bean, [editor.IDProperty]: e });
                                    }}
                                    lista={editor.Options} />
                            </>
                            :
                            <>
                                <label>{editor.Name} </label>
                                <input type="number" className="form-control" name={editor.IDProperty} value={bean[editor.IDProperty ?? editor.DefaultValue]} onChange={actualHandleChange} />
                            </>
                        }
                    </>
                )
            default:
                return (
                    <>
                        <label>{editor.Name}</label>
                        <input type="text" className="form-control" name={editor.IDProperty} value={bean[editor.IDProperty] ?? editor.DefaultValue} onChange={actualHandleChange} />
                    </>
                )
        }
    }

    return { renderInput, SUPPORTED_TYPES };
}
